// What the user clicked in the menu, held until the router says it actually happened.
//
// The drawer highlight and the page title both used to move on the click itself, so answering "Stay" on the
// unsaved-changes prompt left them pointing at a page that was never opened (TTD-151).
//
// Both now record the intent and apply it only on arrival — and both ask THIS function whether they have
// arrived, so the rule exists once rather than being written out twice and drifting.
export type PendingNavigation<T> = { path: string; value: T };

// Matched on the destination PATH, deliberately.
//
// The first attempt compared `pathname.split("/")[1]` against the menu item's key. Every route in this app is
// prefixed with the organisation slug, so that segment is always the org — it matched no item, and the result
// was no highlight and no title anywhere in the portal: worse than the bug being fixed.
//
// A path is what the router moves to, so it can be compared with the route directly and needs no mapping back
// to a menu key. That matters here because the keys are not a function of the route: "dashboard" and
// "analytics" both point at /users/users, and "devices-status" lives at /knox/device-health.
export const hasArrived = <T>(pending: PendingNavigation<T> | null, pathname: string): boolean =>
    !!pending && pending.path === pathname;
